import { AxiosResponse } from "axios";
import StaticFilesReference from "../../constants/staticFilesReference";
import RequestV2 from "./request-v2";
import StaticDocument from "../entities/static-file-entity";

export default class StaticFilesHttpService {
    private static uri: string = 'static-documents';

    public static getDataStaticFilesByReference(reference: StaticFilesReference): Promise<AxiosResponse<StaticDocument[]>> {
        return RequestV2.get(`${this.uri}/all/${reference}`);
    }

    public static getFileByReferenceAndVersion(reference: StaticFilesReference, version: number): Promise<File> {
        return RequestV2.getFile(
            `${this.uri}/file/${reference}/${version}`
        );
    }

    public static uploadStaticFilesReference(reference: StaticFilesReference, file: File): Promise<AxiosResponse<any>> {
        const formData = new FormData();
        formData.append("file", file);
        const config = {
            headers: {
                "Content-Type": "multipart/form-data",
            }
        };
        
        return RequestV2.post(
            `${this.uri}/${reference}`,
            formData,
            config 
        );
    }
}
